import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { KeycloakService } from '@inoventoryapps/keycloak-angular';

export const authGuard: CanActivateFn = async (route, state) => {
    const keycloakService = inject(KeycloakService);
    const isAuthenticated = keycloakService.isLoggedIn();

    if (!isAuthenticated) {
        await keycloakService.login({
            redirectUri: window.location.origin + state.url
        });
    }
    return isAuthenticated;
};
